export default __webpack_public_path__ + "static/media/html.05531684.svg";